const FLAGS: Record<string, string> = {
  USD: '🇺🇸',
  EUR: '🇪🇺',
  GBP: '🇬🇧',
  CHF: '🇨🇭',
  SAR: '🇸🇦',
  JPY: '🇯🇵',
  AUD: '🇦🇺',
  CAD: '🇨🇦',
  TRY: '🇹🇷',
}

export function currencyFlag(code: string): string {
  return FLAGS[code] ?? '💱'
}
